<div class="wrap">

  <mat-card  *ngIf="!isExpired; else expired">
    <ng-container *ngIf="!isLoading">
      <mat-card-header>
        <div mat-card-avatar>
          <fa-icon class="faIconAvatar" [icon]="getFaIcon('faStarFull')"></fa-icon>
        </div>
        <mat-card-title>Donner une note et un avis</mat-card-title>
        <mat-card-subtitle>Votre avis est important !</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content *ngIf="ratingForm">
        <form [formGroup]="ratingForm" (submit)="sendRating()" *ngIf="!formSent">
          <p class="bold">Aidez-nous à améliorer notre service grâce à votre retour d'expérience.</p>

          <p class="italic">Quelle note donnez-vous à notre activité et à la qualité de notre service ? (Détails de l'activité ci-dessous)</p>

          <div class="star-rating-container star-rating-animation" fxLayout="row" fxLayoutAlign="start center">
            <div *ngFor="let star of stars" [ngClass]="[star.class]" (click)="selectStar(star.id)">
              <fa-icon [icon]="getFaIcon('faStarFull')"></fa-icon>
            </div>
          </div>

          <p class="italic">Avez-vous une suggestion pour améliorer notre activité et service ?
            <br> Voulez-vous ajouter un commentaire ?
          </p>

          <mat-form-field appearance="outline">
            <mat-label>Commentaire</mat-label>
            <textarea matInput formControlName="comment"></textarea>
            <mat-error>Le commentaire est requis et ne doit pas dépasser 500 caractères.</mat-error>
          </mat-form-field>

          <button [style.opacity]="ratingForm.valid ? 1 : .5" appChangeColorTheme attribute="bgc" type="submit" class="sendButton"
            [disabled]="ratingForm.invalid" appChangeColorTheme attribute="bgc">Envoyer</button>
        </form>

        <section class="sectionInfos" *ngIf="!formSent">
          <p class="bold">Résumé de votre activité</p>
          <div class="flex" *ngIf="session.clubName && session.offerName">
            <table>
              <tr>
                <th colspan="2">Club</th>
              </tr>
              <tr>
                <td class="offerImageCell" [ngStyle]="{'background-image': 'url(data:image/png;base64,' + session.logo + ')'}"></td>
                <td>{{session.clubName}}</td>
              </tr>

            </table>

            <table>
              <tr>
                <th colspan="2">Offre</th>
              </tr>
              <tr>
                <td class="offerImageCell" [ngStyle]="{'background-image': 'url(data:image/png;base64,' + session.picture + ')'}"></td>
                <td>{{session.offerName}}</td>
              </tr>
            </table>
          </div>


          <table class="tableFull" *ngIf="session.dateLib && session.sessionStartDate && session.sessionEndDate">
            <tr>
              <th colspan="2">Votre session</th>
            </tr>
            <tr>
              <td>{{session.dateLib}}</td>
              <td>Du {{session.sessionStartDate | date : 'short':'UTC'}} au {{session.sessionEndDate | date : 'short':'UTC'}}</td>
            </tr>
          </table>

          <table *ngIf="session.trainees?.length > 0" class="tableFull">
            <tr>
              <th>Votre/vos stagiaire(s)</th>
            </tr>
            <tr *ngFor="let trainee of session.trainees">
              <td>{{trainee.traineeFirstName}} {{trainee.traineeLastName}}</td>
            </tr>
          </table>
        </section>

        <ng-container *ngIf="formSent">
          <p>Merci à vous d'avoir remplis ce formulaire.</p>
        </ng-container>
      </mat-card-content>
    </ng-container>

    <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
  </mat-card>

  <ng-template #expired>
    <mat-card>
      <p class="messageExpired">Ce lien n'est plus valide.</p>
    </mat-card>
  </ng-template>

</div>
